import { Form, Input, Row, Col, Select, Button } from 'antd';
import { useRef, useEffect, useState } from 'react';
import WebEditUniversal, { WebEditUniversalProps } from '../../system/WebEditUniversal';
import getList from '../../../utilsTsx/universal/getList';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import { getService } from '../../system/WebUniversal';
import antdMessage from '../../../utilsTsx/components/system/antdMessage';
import WangeditorV5ForAntD from '../../../utilsTsx/components/wangeditor/WangeditorV5ForAntD';
import systematic from '../../../config/systematic';

const EditComponent = (props: any) => {
    const apiId = 'mqttMsg';
    const { deviceId } = props;
    const [form] = Form.useForm();
    const ref = useRef<any>(undefined);
    const [deviceData, setDeviceData] = useState<any>();
    const [topicData, setTopicData] = useState<any>();
    const [sendTargetData, setSendTargetData] = useState<any>();

    useEffect(() => {
        fetchApi.GET(getService('mf'), {
            query: {
                apiId: 'device',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setDeviceData(res.data);
            }
        });
        fetchApi.GET(getService('mf'), {
            query: {
                apiId: 'topic',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setTopicData(res.data);
            }
        });
        fetchApi.GET(getService('bm'), {
            query: {
                apiId: 'generalData',
                apiVariable: 'sendTarget',
                apiExtend: 'showLists'
            }
        }).then(res => {
            if (res.success) {
                const { sendTarget } = res.data;
                setSendTargetData(sendTarget);
            }
        });
    }, []);

    /**
     * 发送信息
     */
    const sendMsg = (onCancel: any) => {
        form.validateFields() //数据校验
            .then(async (values: any) => {
                fetchApi.POST(getService('mf'), {
                    body: {
                        apiId: 'mqttMsg',
                        apiExtend: 'sendMessage',
                        apiData: {
                            ...values,
                            receiverDeviceId: deviceId
                        }
                    }
                }).then(res => {
                    if (res.success) {
                        antdMessage('success', '发送成功');
                        onCancel?.();
                    } else {
                        antdMessage('error', '发送失败', { description: res.message });
                    }
                });
            })
    }

    let extendProps: WebEditUniversalProps = {
        ...props,
        form,
        apiId,
        serviceId: 'mf',
        titleName: '发送信息',
        isEnter: false,
        displayOptions: {
            width: 1000,
            footer: ({ onCancel }: any) => (
                <>
                    <Button onClick={() => sendMsg(onCancel)}>发送信息</Button>
                    <Button onClick={onCancel}>取消</Button>
                </>
            )
        },
        formOptions: {
            instance: form,
            children: (
                <Row gutter={[8, 0]}>
                    <Col span={8}>
                        <Row gutter={[8, 0]}>
                            <Col span={24}>
                                <Form.Item
                                    label="目标设备"
                                    name="receiverDeviceId"
                                    tooltip="按目标设备处理消息方式处理信息，目标设备必需订阅相关主题才能收到信息。"
                                    initialValue={deviceId}>
                                    <Select
                                        disabled={true}
                                        allowClear
                                        placeholder="请选择设备"
                                        showSearch={{
                                            optionFilterProp: 'children',
                                            filterOption: (input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}>
                                        {getList.general(deviceData, { itemName: 'deviceName' })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="发送目标"
                                    name="sendTargetId"
                                    tooltip="消息的发送方向，例如：设备、平台、广播等，来源于基础字典。用于区分上行/下行及广播消息。">
                                    <Select
                                        allowClear
                                        placeholder="请选择发送目标"
                                        showSearch={{
                                            optionFilterProp: 'children',
                                            filterOption: (input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}>
                                        {getList.general(sendTargetData)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="主题id"
                                    name="topicId"
                                    tooltip="MQTT 主题（Topic），来源于“主题”表。用于标识消息的发布/订阅通道，如：device/+/report。">
                                    <Select
                                        allowClear
                                        placeholder="请选择主题"
                                        showSearch={{
                                            optionFilterProp: 'children',
                                            filterOption: (input, option: any) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }}>
                                        {getList.general(topicData, { itemName: 'topicName', includeNull: true })}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item
                                    label="自定主题"
                                    name="topic"
                                    tooltip="主题id需选为null，可以自定主题">
                                    <Input />
                                </Form.Item>
                            </Col>

                        </Row>
                    </Col>
                    <Col span={16}>
                        <Form.Item
                            label=""
                            name="payload"
                            initialValue={'您好,测试'}>
                            <WangeditorV5ForAntD
                                key={deviceId}
                                id={`deviceSendMsg${deviceId}`}
                                title='信息'
                                displayMode="editor"
                                defaultService={systematic.bmService}
                                style={{ height: 300 }}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            )
        }
    };

    return (<WebEditUniversal ref={ref} {...extendProps} />)
}

export default EditComponent;